export const applicationDocuments = [
  "Passport first page",
  "Profile image",
  "Highest diploma document (English Version)",
  "Transcript of records (English Version)",
  "Resume or CV",
  "Recommendation letter",
  "English Proficiency Test Score (Optional)",
];

export const requireApplicationDocuments = [
  "Passport first page",
  "Profile image",
  "Highest diploma document (English Version)",
  "Transcript of records (English Version)",
];

export const rejectReasons = [
  {
    label: "Offer does not meet expectations",
    value: "Offer does not meet expectations",
  },
  {
    label: "Changed study plan",
    value: "Changed study plan",
  },
  {
    label: "Decided to study in a different country",
    value: "Decided to study in a different country",
  },
  {
    label: "Received a better offer from another university",
    value: "Received a better offer from another university",
  },
  {
    label: "Personal reasons",
    value: "Personal reasons",
  },
  {
    label: "Career opportunities or job offer",
    value: "Career opportunities or job offer",
  },
  {
    label: "Financial concerns",
    value: "Financial concerns",
  },
  {
    label: "Other",
    value: "Other",
  },
];
